import actions from './actions';

const {
  GET_PAYNET_BALANCE_BEGIN,
  GET_PAYNET_BALANCE_SUCCESS,
  GET_PAYNET_BALANCE_ERR,
  GET_PAYNET_MERCHANTS_BEGIN,
  GET_PAYNET_MERCHANTS_SUCCESS,
  GET_PAYNET_MERCHANTS_ERR,
  GET_PAYNET_PRODUCTS_BEGIN,
  GET_PAYNET_PRODUCTS_SUCCESS,
  GET_PAYNET_PRODUCTS_ERR,
} = actions;

const initState = {
  loadingGetPaynetBalance: false,
  errorGetPaynetBalance: null,
  balance: 0,

  loadingGetPaynetMerchants: false,
  errorGetPaynetMerchants: null,
  categories: [],

  loadingGetPaynetProducts: false,
  errorGetPaynetProducts: null,
  products: [],
};

/**
 *
 * @todo impure state mutation/explaination
 */
const paynetReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_PAYNET_MERCHANTS_BEGIN:
      return {
        ...state,
        loadingGetPaynetMerchants: true,
        errorGetPaynetMerchants: null,
      };
    case GET_PAYNET_MERCHANTS_SUCCESS:
      return {
        ...state,
        categories: data,
        loadingGetPaynetMerchants: false,
        errorGetPaynetMerchants: null,
      };
    case GET_PAYNET_MERCHANTS_ERR:
      return {
        ...state,
        loadingGetPaynetMerchants: false,
        errorGetPaynetMerchants: err,
      };

    case GET_PAYNET_BALANCE_BEGIN:
      console.log('paynet balance begin:  ');

      return {
        ...state,
        loadingGetPaynetBalance: true,
        errorGetPaynetBalance: null,
      };
    case GET_PAYNET_BALANCE_SUCCESS:
      console.log('paynet balance data:  ', data);
      return {
        ...state,
        balance: data,
        loadingGetPaynetBalance: false,
        errorGetPaynetBalance: null,
      };
    case GET_PAYNET_BALANCE_ERR:
      console.log('paynet balance failed:  ');

      return {
        ...state,
        loadingGetPaynetBalance: false,
        errorGetPaynetBalance: err,
      };

    case GET_PAYNET_PRODUCTS_BEGIN:
      return {
        ...state,
        loadingGetPaynetProducts: true,
        errorGetPaynetProducts: null,
      };
    case GET_PAYNET_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: data,
        loadingGetPaynetProducts: false,
        errorGetPaynetProducts: null,
      };
    case GET_PAYNET_PRODUCTS_ERR:
      return {
        ...state,
        loadingGetPaynetProducts: false,
        errorGetPaynetProducts: err,
      };
    default:
      return state;
  }
};
export { paynetReducer };
